import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ptl-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content></ng-content>`,
  styleUrls: ['./ptl-card.component.scss'],
})
export class PtlCardComponent {}
